import { render, staticRenderFns } from "./RequestDataPend.vue?vue&type=template&id=15b3ace5&scoped=true"
import script from "./RequestDataPend.vue?vue&type=script&lang=js"
export * from "./RequestDataPend.vue?vue&type=script&lang=js"
import style0 from "./RequestDataPend.vue?vue&type=style&index=0&id=15b3ace5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b3ace5",
  null
  
)

export default component.exports